import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE } from '../../Configuration'
import usePageTitle from '../../hooks/use-page-title'
import { RoleContext } from '../../store/role-context-provider'
import { SelectionContextProvider } from '../../store/selection-context-provider'
import MyInquiriesList from './my-inquiries-list'

const MyInquiries = () => {
  usePageTitle(PAGE_TITLE.MY_INQUIRIES)
  const navigate = useNavigate()
  const { allMPF, isLoading } = useContext(RoleContext)
  if (!isLoading) {
    if (!allMPF) {
      navigate('/accessdenied')
    }
  }
  return (
    <SelectionContextProvider>
      <MyInquiriesList />
    </SelectionContextProvider>
  )
}
export default MyInquiries
